import { Appointment, APPOINTMENT_STATUS } from "@elixir/types";
import {
  cancelAppointmentReminders,
  getMe,
  updateAppointment,
} from "../../utils/bridges/methods";
import { logAndGetErrorResponse } from "../error";
import { ControllerReturnType } from "../types";
import {
  trackAppointmentActivity,
  AptActivityType,
} from "./appointment-activity";

export default async function markNoShow({
  appointment,
}: {
  appointment: Pick<Appointment, "aid" | "doctor_oid">;
}): Promise<ControllerReturnType> {
  try {
    const { aid, doctor_oid } = appointment;

    const status = APPOINTMENT_STATUS.NO_SHOW;

    await updateAppointment({
      data: {
        status,
      },
      aid,
    });

    //TODO - Add activity update
    cancelAppointmentReminders({ aid });
    trackAppointmentActivity({
      aid,
      activity: AptActivityType.MARKED_NOSHOW,
    });
    return { success: true };
  } catch (e) {
    return logAndGetErrorResponse(e);
  }
}
